import GigyaLoginController from '@/utils/Controllers/Gigya/GigyaLoginController';
import GigyaForgottenPasswordController from '@/utils/Controllers/Gigya/GigyaForgottenPasswordController';

document.addEventListener('DOMContentLoaded', () => {
  GigyaLoginController.init();
  GigyaForgottenPasswordController.init();
});
